"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Android = _interopRequireDefault(require("@rsuite/icon-font/lib/platform/Android"));

// Generated by script, don't edit it please.
var Android = (0, _createSvgIcon["default"])({
  as: _Android["default"],
  ariaLabel: 'android',
  category: 'platform',
  displayName: 'Android'
});
var _default = Android;
exports["default"] = _default;
module.exports = exports.default;